var React = require('react');

function AboutInline (props) {
    return React.createElement("path",props);
}

AboutInline.defaultProps = {"d":"M18,27.5c-4.68,0-14,2.34-14,7V38h28v-3.5C32,29.84,22.68,27.5,18,27.5z M8.68,34\n\tC10.36,32.84,14.42,31.5,18,31.5s7.639999,1.34,9.32,2.5H8.68z M18,24c3.860001,0,7-3.139999,7-7s-3.139999-7-7-7s-7,3.14-7,7\n\tS14.14,24,18,24z M18,14c1.66,0,3,1.34,3,3s-1.34,3-3,3s-3-1.34-3-3S16.34,14,18,14z M32.080002,27.620001\n\tC34.400002,29.299999,36,31.540001,36,34.5V38h8v-3.5C44,30.459999,37,28.16,32.080002,27.620001L32.080002,27.620001z M30,24\n\tc3.860001,0,7-3.139999,7-7s-3.139999-7-7-7c-1.08,0-2.08,0.26-3,0.7c1.26,1.78,2,3.96,2,6.3s-0.74,4.52-2,6.299999\n\tC27.92,23.74,28.92,24,30,24z"};

module.exports = AboutInline;

AboutInline.default = AboutInline;
